import { useContext, useLayoutEffect } from "react";
import { IPortuguesePurchasePathContext } from "../config/interface";
import { PortuguesePurchasePathContext } from "../PortuguesePurchasePath";
import PPOrderDetail from "./steps/PPOrderDetail";
import PPOrderForm from "./steps/PPOrderForm";
import PPPaymentForm from "./steps/PPPaymentForm";
import PPQuoteDetail from "./steps/PPQuoteDetail";
import PPQuoteForm from "./steps/PPQuoteForm";

const Step = () => {
  const { currentStep } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;

  let stepContent: any;

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  switch (currentStep) {
    case 0:
      stepContent = <PPQuoteForm />;
      break;
    case 1:
      stepContent = <PPQuoteDetail />;
      break;
    case 2:
      stepContent = <PPOrderForm />;
      break;

    case 3:
      stepContent = <PPPaymentForm />;
      break;
    case 4:
      stepContent = <PPOrderDetail />;
      break;
    default:
      stepContent = <PPQuoteForm />;
      break;
  }

  return stepContent;
};

export default Step;
